import React from 'react';
import { useTranslate } from '@agilepoint/wat-react';
import { CenteredSpinner } from 'common';
import { useUserSettingsQuery } from '../queries';
import { UserSettings } from '../component/parts/user-details/user-settings';
import { IGetTextData, useSaveTextDataQuery } from 'modules/shared/queries';

export const UserSettingsContainer = React.memo((props: { removePopup: (id: string) => void }) => {
    const { data, isLoading, error } = useUserSettingsQuery();
    const { mutateAsync } = useSaveTextDataQuery();
    const translate = useTranslate();

    const onSaveUserDetails = (payload: IGetTextData) => mutateAsync(payload);

    if (isLoading) {
        return <CenteredSpinner height="480px" width="100%" size='small' spinnerType='indeterminate' text={translate('modules.userActions.userSettings.loadingUserSettings')} />;
    }

    if (data) {
        const { TextData } = data;
        const userDetails = JSON.parse(TextData);

        return (
            <UserSettings userDetails={userDetails} onSaveUserDetails={onSaveUserDetails} removePopup={props.removePopup} />
        );
    }

    if (error) {
        return (
            <>
                <span>Error: {error}</span>
            </>
        );
    }

    return <></>;
});
